import { ModelBase } from '../../core/model/model-base';
import { Translation } from '../../core/model/translation';

// Mirrors LettingFeatureReferenceKind in the API.
export enum LettingFeatureReferenceType {
  NotIncluded = 0,
  Included = 1,
}

export class LettingFeature extends ModelBase {
  constructor(context?: any) {
    super();
    if (context) {
      this.phrase = context.phrase;
      this.id = context.id;
      this.lettingFeatureId = context.lettingFeatureId;
      this.isActive = context.isActive ?? true;
    }
  }

  phrase: Translation[];
  lettingFeatureId?: string;
  isActive: boolean = true;

  toString() {
    return `${this.phrase.find(x => !!x.translationText)?.translationText || ''}`;
  }
}
